<div class="ui-fluid ui-g-12 store-filter-section">
  <!-- Filtri -->
  <div class="ui-g-2">{{ 'campaign.filteredBy' | translate }}</div>
  <div class="ui-g-10 ui-g-nopad">
    <!-- Filtro Classificazioni  -->
    <div class="ui-g-4">
      <p-multiSelect
        class="store-filter-multiselect"
        defaultLabel="{{ 'campaign.classification' | translate }}"
        [style]="{ width: '100%' }"
        [options]="classifications"
        [(ngModel)]="filter.classificationNames">
      </p-multiSelect>
    </div>
    <!-- Filtro Insegna -->
    <div class="ui-g-4">
      <p-multiSelect
        class="store-filter-multiselect"
        defaultLabel="{{ 'campaign.sign' | translate }}"
        [style]="{ width: '100%' }"
        [filter]="true"
        [options]="insegne"
        [(ngModel)]="filter.insegna">
      </p-multiSelect>
    </div>
    <!-- Filtro Gruppo -->
    <div class="ui-g-4">
      <p-dropdown
        [style]="{ width: '100%' }"
        [filter]="true"
        [options]="groupNames"
        [(ngModel)]="filter.gruppo"
      >
      </p-dropdown>
    </div>
  </div>
  <!-- Buttons Filtri -->
  <div class="ui-g-12">
    <div class="ui-g-4"></div>
    <!-- Reset -->
    <div class="add ui-g-2">
      <button pButton type="button" class="reset" label="Reset" (click)="initFilter()"></button>
    </div>
    <!-- Applica -->
    <div class="add ui-g-2">
      <button pButton type="button" class="apply" label="{{ 'common.apply' | translate }}" (click)="confirmFilters()"></button>
    </div>
    <div class="ui-g-4"></div>
  </div>
</div>
<!-- Buttons Azioni -->
<div class="ui-dialog-inner">
  <div class="ui-g-12">
    <div class="saved">{{stores.length}} {{ 'campaign.storesFound' | translate }}</div>
  </div>
  <div class="ui-g-12">
    <hr style="border-top:0px; border-color:#dde3e6">
  </div>
  <!-- Seleziona Tutti -->
  <div class="ui-g-2">
    <div class="select-all-btn" (click)="selectAll()">{{ 'common.selectAll' | translate }}</div>
  </div>
  <!-- Deseleziona Tutti -->
  <div class="ui-g-2">
    <div class="select-all-btn" (click)="unselectAll()">{{ 'common.unselectAll' | translate }}</div>
  </div>
  <!-- Salva come Gruppo -->
  <div class="ui-g-4 text-right" *ngIf="!saveAsGroup">
    <button pButton type="button" class="save-as-group-btn" label="{{ 'campaign.saveAsGroup' | translate }}" (click)="inputGroupName(true)"></button>
  </div>
  <!-- Campo Salvataggio Gruppo -->
  <div class="ui-g-4 save-as-group-field" *ngIf="saveAsGroup">
    <div class="ui-g-8 ui-g-nopad">
      <input type="text" pInputText placeholder="{{ 'campaign.setGroupName' | translate }}" [(ngModel)]="newGroupName" />
    </div>
    <div class="ui-g-4 ui-g-nopad flex-align-center">
      <button pButton type="button" class="nosuccess" icon="fa fa-times" (click)="inputGroupName(false)"></button>
      <button pButton type="button" class="success" icon="fa fa-check" (click)="saveGroup()"></button>
    </div>
  </div>
  <!-- Aggiungi Negozi Selezionati -->
  <div class="ui-g-4 text-right">
    <button pButton type="button" class="add-selected-stores-btn" label="{{ 'common.add' | translate }}" (click)="addStores()"></button>
  </div>
  <!-- Lista Negozi -->
  <div class="ui-g-12">
    <p-dataTable [value]="stores" class="store-table">
      <p-column styleClass="col-button">
        <ng-template let-col let-store="rowData" pTemplate="body">
          <p-checkbox name="selectedStoresId" value="{{ store.id }}" [(ngModel)]="selectedStoresId"></p-checkbox>
        </ng-template>
      </p-column>
      <p-column field="host_code" header="{{ 'common.storeCode' | translate }}"></p-column>
      <p-column field="name" header="{{ 'common.storeName' | translate }}"></p-column>
      <p-column field="classificationDetailCode" header="{{ 'campaign.areas' | translate }}"></p-column>
      <p-column field="city" header="{{ 'common.city' | translate }}"></p-column>
      <p-column field="address_1" header="{{ 'common.address' | translate }}"></p-column>
    </p-dataTable>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-add-stores/campaign-add-stores.component.html